'use client';

import * as React from 'react';
import { useStore } from '@base-ui/utils/store';
import { useSchedulerStoreContext } from "../../use-scheduler-store-context/useSchedulerStoreContext.mjs";
import { schedulerOccurrenceSelectors, schedulerOtherSelectors } from "../../scheduler-selectors/index.mjs";
export function useEvent(parameters) {
  const {
    start,
    end,
    eventId
  } = parameters;
  const store = useSchedulerStoreContext();
  const started = useStore(store, schedulerOccurrenceSelectors.isStarted, start);
  const ended = useStore(store, schedulerOccurrenceSelectors.isEnded, end);
  const editing = useStore(store, schedulerOtherSelectors.isEditedEvent, eventId);
  const state = React.useMemo(() => ({
    started,
    ended,
    editing
  }), [started, ended, editing]);
  return {
    state
  };
}